import Parameter from "~/common/components/Parameter";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectCarriagesPerGuidewayAmount, selectRailAmount } from "~/features/configurator/Linear/redux/selectors";

export const LinearSummaryParams = () => {
  const { t } = useTranslation();
  const railAmount = useSelector(selectRailAmount);
  const carriageAmount = useSelector(selectCarriagesPerGuidewayAmount);

  return (
    <>
      <Parameter
        label={t("cartPage.systemLayout.label")}
        value={
          <>
            <div>
              {t("linearConfigSummary.guideway.info", {
                count: railAmount,
              }) + ","}
            </div>
            <div>
              {t("linearConfigSummary.carriages.info", {
                count: carriageAmount,
              })}
            </div>
          </>
        }
      />
    </>
  );
};
